/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Chain_To_Previous_EventInputs */



/**
* | output |
* | --- |
* | "Chain To Previous Event" |
*
* @param {Shortcut_Keys_Name_Chain_To_Previous_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_chain_to_previous_event = /** @type {((inputs?: Shortcut_Keys_Name_Chain_To_Previous_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Chain_To_Previous_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chainer a l'evenement precedent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbindung zum vorherigen Ereignis herstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Concatena all'evento precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Цепочка к предыдущему событию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cadena al evento anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("链至上一个事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前のイベントへのチェーン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछली घटना से जुड़ाव")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Encadeamento ao evento anterior")
	return /** @type {LocalizedString} */ ("Chain To Previous Event")
});